var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list-table" },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.dataList,
            "row-class-name": _vm.tableRowClassName,
          },
          on: { "selection-change": _vm.onSelectionChange },
        },
        [
          _vm._l(
            _vm.config,
            function ({ type, prop, label, width, slot, align, fixed }) {
              return [
                type
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        label: label,
                        type: type,
                        "min-width": width,
                        align: align,
                      },
                    })
                  : slot
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        fixed: fixed,
                        align: align,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                slot === "html"
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          scope.row.goodsNo +
                                            "<br>" +
                                            scope.row.categoryName
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                                slot === "caozuo"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item item2",
                                          style: {
                                            zIndex: 100 - scope.$index,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "hint_pr-operation",
                                            },
                                            [
                                              _vm.typeStr === "all"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.toOtherPages(
                                                                        scope
                                                                          .row
                                                                          .subsetStatus ==
                                                                          "99" &&
                                                                          scope
                                                                            .row
                                                                            .applierName ==
                                                                            _vm
                                                                              .userInfo
                                                                              .reallyName
                                                                          ? "modify_order"
                                                                          : "orderDetails",
                                                                        scope.row,
                                                                        "modify_order"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "查看/编辑"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          scope.row
                                                            .applierName ==
                                                            _vm.userInfo
                                                              .reallyName &&
                                                          scope.row
                                                            .bonusTypeLabel &&
                                                          scope.row
                                                            .bonusReviewStatus !==
                                                            0 &&
                                                          scope.row
                                                            .bonusReviewStatus !==
                                                            2 &&
                                                          scope.row
                                                            .isAppealPass !== 1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "发起提成申诉",
                                                                            "650px",
                                                                            "faqishensu",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "发起提成申诉"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .bonusReviewStatusLabel
                                                            ? _c(
                                                                "li",
                                                                [
                                                                  scope.row
                                                                    .bonusReviewStatus ===
                                                                  4
                                                                    ? [
                                                                        _c(
                                                                          "label",
                                                                          {
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onTableShowDialog(
                                                                                    "查看修改证明",
                                                                                    "640px",
                                                                                    "chakanshensu",
                                                                                    scope.row,
                                                                                    scope.$index
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "查看修改证明"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    : [
                                                                        _c(
                                                                          "label",
                                                                          {
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onTableShowDialog(
                                                                                    "查看提成申诉",
                                                                                    "640px",
                                                                                    "chakanshensu",
                                                                                    scope.row,
                                                                                    scope.$index
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "查看提成申诉"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                ],
                                                                2
                                                              )
                                                            : _vm._e(),
                                                          scope.row
                                                            .bonusReviewStatusLabel
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "申诉记录",
                                                                            "640px",
                                                                            "shensujilu",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "申诉记录"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .bonusReviewStatus !==
                                                            0 &&
                                                          _vm.parArrayArr.indexOf(
                                                            "fqxgtc"
                                                          ) != -1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "发起修改提成",
                                                                            "640px",
                                                                            "shensuxiugai",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "发起修改提成"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "show-block",
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _vm.typeStr === "close"
                                                ? [
                                                    _c(
                                                      "label",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toOtherPages(
                                                              "orderDetails",
                                                              scope.row,
                                                              "modify_order"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("查看/编辑")]
                                                    ),
                                                  ]
                                                : _vm.typeStr === "bonusIng"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "查看提成申诉",
                                                                        "640px",
                                                                        "chakanshensu",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "查看提成申诉"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "申诉记录",
                                                                        "640px",
                                                                        "shensujilu",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "申诉记录"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "show-block",
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.typeStr === "bonusReject"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          scope.row
                                                            .applierName ==
                                                            _vm.userInfo
                                                              .reallyName &&
                                                          scope.row
                                                            .isAppealPass !== 1
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onTableShowDialog(
                                                                          "发起提成申诉",
                                                                          "650px",
                                                                          "faqishensu",
                                                                          scope.row,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("label", [
                                                                    _vm._v(
                                                                      "发起提成申诉"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "查看提成申诉",
                                                                        "640px",
                                                                        "chakanshensu",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "查看提成申诉"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "申诉记录",
                                                                        "640px",
                                                                        "shensujilu",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "申诉记录"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _vm.parArrayArr.indexOf(
                                                            "fqxgtc"
                                                          ) != -1
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onTableShowDialog(
                                                                          "发起修改提成",
                                                                          "640px",
                                                                          "shensuxiugai",
                                                                          scope.row,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("label", [
                                                                    _vm._v(
                                                                      "发起修改提成"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "show-block",
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.typeStr === "bonusSuccess"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "查看提成申诉",
                                                                        "640px",
                                                                        "chakanshensu",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "查看提成申诉"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "申诉记录",
                                                                        "640px",
                                                                        "shensujilu",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "申诉记录"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _vm.parArrayArr.indexOf(
                                                            "fqxgtc"
                                                          ) != -1
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onTableShowDialog(
                                                                          "发起修改提成",
                                                                          "640px",
                                                                          "shensuxiugai",
                                                                          scope.row,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("label", [
                                                                    _vm._v(
                                                                      "发起修改提成"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "show-block",
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.typeStr === "bonusEdit"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "申诉记录",
                                                                        "640px",
                                                                        "shensujilu",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "申诉记录"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c(
                                                            "li",
                                                            {
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onTableShowDialog(
                                                                      "查看修改证明",
                                                                      "640px",
                                                                      "chakanshensu",
                                                                      scope.row,
                                                                      scope.$index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("label", [
                                                                _vm._v(
                                                                  "查看修改证明"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          scope.row
                                                            .applierName ==
                                                            _vm.userInfo
                                                              .reallyName &&
                                                          scope.row
                                                            .bonusKnowFlag === 0
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onTableShowDialog(
                                                                          "确认修改",
                                                                          "640px",
                                                                          "confirmModify",
                                                                          scope.row,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("label", [
                                                                    _vm._v(
                                                                      "确认修改"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "show-block",
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.typeStr === "close"
                                                ? [
                                                    _c(
                                                      "label",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toOtherPages(
                                                              "orderDetails",
                                                              scope.row,
                                                              "modify_order"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("查看/编辑")]
                                                    ),
                                                  ]
                                                : _vm.typeStr === "operation"
                                                ? [
                                                    _c(
                                                      "label",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toOtherPages(
                                                              scope.row
                                                                .subsetStatus ==
                                                                "99" &&
                                                                scope.row
                                                                  .applierName ==
                                                                  _vm.userInfo
                                                                    .reallyName
                                                                ? "modify_order"
                                                                : "orderDetails",
                                                              scope.row,
                                                              "saleAfter"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("查看")]
                                                    ),
                                                  ]
                                                : _vm.typeStr == "submitted"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          _vm.isShowCom.detail
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.toOtherPages(
                                                                            scope
                                                                              .row
                                                                              .subsetStatus ==
                                                                              "99" &&
                                                                              scope
                                                                                .row
                                                                                .applierName ==
                                                                                _vm
                                                                                  .userInfo
                                                                                  .reallyName
                                                                              ? "modify_order"
                                                                              : "orderDetails",
                                                                            scope.row,
                                                                            "modify_order"
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "查看/编辑"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .cancelOrder
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.cancelOrderWait(
                                                                            scope.row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "取消订单"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .cancelOrderMsg &&
                                                          scope.row
                                                            .applierName ==
                                                            _vm.userInfo
                                                              .reallyName &&
                                                          scope.row
                                                            .subsetStatus == 3
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.cancelOrderMsg(
                                                                            scope.row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "取消订单"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .submitOrder
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onResubmitOrder(
                                                                            scope
                                                                              .row
                                                                              .orderId
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "提交订单"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .submitOrderAgain &&
                                                          scope.row
                                                            .applierName ==
                                                            _vm.userInfo
                                                              .reallyName &&
                                                          scope.row
                                                            .approveStatus == 3
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onResubmitOrder(
                                                                            scope
                                                                              .row
                                                                              .orderId
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "重新提交"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .examineProcess
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "审核流程",
                                                                            "640px",
                                                                            "shenheStep",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "审核流程"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .seeExpress
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "查看物流",
                                                                            "500px",
                                                                            "logisticsMessageOne",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "查看物流"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .modifyExpress
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "修改快递单号",
                                                                            "500px",
                                                                            "modifyOrderNoOne",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "修改快递单号"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .confirmReceipt
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onConfirmReceipt(
                                                                            scope.row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "确认收货"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isShowCom
                                                            .copyExpress
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.copyInfo(
                                                                            scope.row,
                                                                            "express"
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "复制物流单号"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .applierName ==
                                                                  _vm.userInfo
                                                                    .reallyName,
                                                                expression:
                                                                  "scope.row.applierName == userInfo.reallyName",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "show-block",
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.typeStr == "auditOrder"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.toOtherPages(
                                                                        "orderDetails",
                                                                        scope.row,
                                                                        "examination"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("查看")]
                                                            ),
                                                          ]),
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "审核流程",
                                                                        "640px",
                                                                        "shenheStep",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("进度")]
                                                            ),
                                                          ]),
                                                          scope.row
                                                            .approveStatus ==
                                                            1 &&
                                                          scope.row
                                                            .canDoApprove == 1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "审核",
                                                                            "640px",
                                                                            "shenheList",
                                                                            scope.row,
                                                                            false
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "审核"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.typeStr ==
                                                  "commissionOrder"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.toOtherPages(
                                                                        "orderDetails",
                                                                        scope.row,
                                                                        "examinationCommission"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "查看订单"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c(
                                                            "li",
                                                            [
                                                              scope.row
                                                                .auditStatus ===
                                                              4
                                                                ? [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.onTableShowDialog(
                                                                                "查看修改证明",
                                                                                "640px",
                                                                                "chakanshensu",
                                                                                scope.row,
                                                                                scope.$index
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "查看修改证明"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                : [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.onTableShowDialog(
                                                                                "查看提成申诉",
                                                                                "640px",
                                                                                "chakanshensu",
                                                                                scope.row,
                                                                                scope.$index
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "查看提成申诉"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                            ],
                                                            2
                                                          ),
                                                          scope.row
                                                            .auditStatus === 0
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "提成申诉审核",
                                                                            "640px",
                                                                            "auditshensu",
                                                                            scope.row,
                                                                            false
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "审核"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onTableShowDialog(
                                                                        "申诉记录",
                                                                        "640px",
                                                                        "shensujilu",
                                                                        scope.row,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "申诉记录"
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.typeStr == "recordList"
                                                ? [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c("ul", [
                                                          _c("li", [
                                                            _c(
                                                              "label",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.toOtherPages(
                                                                        "afterSaleDetails",
                                                                        scope.row,
                                                                        "Details"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("查看")]
                                                            ),
                                                          ]),
                                                          scope.row
                                                            .afterSaleStepCode ==
                                                          1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "审核流程",
                                                                            "640px",
                                                                            "shenheStep",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "进度"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .afterSaleStepCode ==
                                                            1 &&
                                                          scope.row
                                                            .canDoApprove == 1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "审核",
                                                                            "640px",
                                                                            "afterSaleShenhe",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "审核"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.parArrayArr.indexOf(
                                                            "chsh"
                                                          ) != -1 &&
                                                          scope.row
                                                            .afterSaleStepCode !=
                                                            8
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.revocationAfterSales(
                                                                            "撤回售后",
                                                                            "640px",
                                                                            "cancelService",
                                                                            scope
                                                                              .row
                                                                              .afterNo
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "撤回售后"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .afterSaleStepCode ==
                                                          3
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "物流信息-退货",
                                                                            "640px",
                                                                            "progress",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "查看退货物流"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .afterSaleStepCode ==
                                                            3 &&
                                                          (scope.row
                                                            .createdUserName ===
                                                            _vm.userInfo
                                                              .reallyName ||
                                                            _vm.userInfo.id ===
                                                              1)
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "修改退货单号",
                                                                            "500px",
                                                                            "modifyOrderNoOneTui",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "修改退货单号"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .afterSaleStepCode ==
                                                            5 &&
                                                          _vm.parArrayArr.indexOf(
                                                            "after_xghhdh"
                                                          ) != -1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "修改换货单号",
                                                                            "500px",
                                                                            "modifyOrderNoTwo",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "修改换货单号"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .afterSaleStepCode ==
                                                            2 &&
                                                          (scope.row
                                                            .createdUserName ===
                                                            _vm.userInfo
                                                              .reallyName ||
                                                            _vm.userInfo.id ===
                                                              1)
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "退货单号",
                                                                            "500px",
                                                                            "modifyOrderNoOneTui",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "退货单号"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .afterSaleStepCode ==
                                                            4 &&
                                                          _vm.parArrayArr.indexOf(
                                                            "order_huanhuojichu"
                                                          ) != -1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "换货寄出",
                                                                            "500px",
                                                                            "modifyOrderNoTwo",
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "换货寄出"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          scope.row
                                                            .afterSaleStepCode ==
                                                          5
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onTableShowDialog(
                                                                            "物流信息-换货",
                                                                            "640px",
                                                                            "2",
                                                                            scope.row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "查看换货物流"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          (scope.row
                                                            .afterSaleStepCode ==
                                                            3 ||
                                                            scope.row
                                                              .afterSaleStepCode ==
                                                              5) &&
                                                          (scope.row
                                                            .createdUserName ===
                                                            _vm.userInfo
                                                              .reallyName ||
                                                            _vm.userInfo.id ===
                                                              1 ||
                                                            _vm.parArrayArr.indexOf(
                                                              "main_confirmReceipt_wuliu"
                                                            ) != -1)
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onConfirmTake(
                                                                            scope.row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "确认收货"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.parArrayArr.indexOf(
                                                            "After_sales_registration"
                                                          ) != -1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.openLoginDialog(
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "售后件登记"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm.parArrayArr.indexOf(
                                                            "Registration_history"
                                                          ) != -1
                                                            ? _c("li", [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.openLoginDialogRecord(
                                                                            scope.row,
                                                                            scope.$index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "登记记录"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]),
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._v("操作"),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-arrow-down",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.typeStr == "afterOrder"
                                                ? [
                                                    _c(
                                                      "label",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toOtherPages(
                                                              "afterSaleRecordList",
                                                              scope.row,
                                                              "afterOrder"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("售后记录")]
                                                    ),
                                                  ]
                                                : [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          width: "120",
                                                          "popper-class":
                                                            "caozuo-popover",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _vm.typeStr !== "all" &&
                                                        _vm.typeStr !== "close"
                                                          ? _c(
                                                              "ul",
                                                              [
                                                                _vm.isShowCom
                                                                  .detail
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.toOtherPages(
                                                                                  scope
                                                                                    .row
                                                                                    .subsetStatus ==
                                                                                    "99" &&
                                                                                    scope
                                                                                      .row
                                                                                      .applierName ==
                                                                                      _vm
                                                                                        .userInfo
                                                                                        .reallyName
                                                                                    ? "modify_order"
                                                                                    : "orderDetails",
                                                                                  scope.row,
                                                                                  "modify_order"
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "查看/编辑"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .cancelOrder
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.cancelOrderWait(
                                                                                  scope.row
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "取消订单"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .cancelOrderMsg &&
                                                                scope.row
                                                                  .applierName ==
                                                                  _vm.userInfo
                                                                    .reallyName &&
                                                                scope.row
                                                                  .subsetStatus ==
                                                                  3
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.cancelOrderMsg(
                                                                                  scope.row
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "取消订单"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .submitOrder
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onResubmitOrder(
                                                                                  scope
                                                                                    .row
                                                                                    .orderId
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "提交订单"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .submitOrderAgain &&
                                                                scope.row
                                                                  .applierName ==
                                                                  _vm.userInfo
                                                                    .reallyName &&
                                                                scope.row
                                                                  .approveStatus ==
                                                                  3
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onResubmitOrder(
                                                                                  scope
                                                                                    .row
                                                                                    .orderId
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "重新提交"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .examineProcess
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onTableShowDialog(
                                                                                  "审核流程",
                                                                                  "640px",
                                                                                  "shenheStep",
                                                                                  scope.row,
                                                                                  scope.$index
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "审核流程"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .seeExpress
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onTableShowDialog(
                                                                                  "查看物流",
                                                                                  "500px",
                                                                                  "logisticsMessageOne",
                                                                                  scope.row,
                                                                                  scope.$index
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "查看物流"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .modifyExpress
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onTableShowDialog(
                                                                                  "修改快递单号",
                                                                                  "500px",
                                                                                  "modifyOrderNoOne",
                                                                                  scope.row,
                                                                                  scope.$index
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "修改快递单号"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .confirmReceipt
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onConfirmReceipt(
                                                                                  scope.row
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "确认收货"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.isShowCom
                                                                  .copyExpress
                                                                  ? _c("li", [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.copyInfo(
                                                                                  scope.row,
                                                                                  "express"
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "复制物流单号"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.typeStr ==
                                                                  "beforeShipment" ||
                                                                _vm.typeStr ==
                                                                  "waitSignFor" ||
                                                                _vm.typeStr ==
                                                                  "finish"
                                                                  ? [
                                                                      scope.row
                                                                        .applierName ==
                                                                        _vm
                                                                          .userInfo
                                                                          .reallyName &&
                                                                      scope.row
                                                                        .bonusTypeLabel &&
                                                                      scope.row
                                                                        .bonusReviewStatus !==
                                                                        0 &&
                                                                      scope.row
                                                                        .bonusReviewStatus !==
                                                                        2 &&
                                                                      scope.row
                                                                        .isAppealPass !==
                                                                        1
                                                                        ? _c(
                                                                            "li",
                                                                            [
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.onTableShowDialog(
                                                                                          "发起提成申诉",
                                                                                          "650px",
                                                                                          "faqishensu",
                                                                                          scope.row,
                                                                                          scope.$index
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "发起提成申诉"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      scope.row
                                                                        .bonusReviewStatusLabel
                                                                        ? _c(
                                                                            "li",
                                                                            [
                                                                              scope
                                                                                .row
                                                                                .bonusReviewStatus ===
                                                                              4
                                                                                ? [
                                                                                    _c(
                                                                                      "label",
                                                                                      {
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.onTableShowDialog(
                                                                                                "查看修改证明",
                                                                                                "640px",
                                                                                                "chakanshensu",
                                                                                                scope.row,
                                                                                                scope.$index
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "查看修改证明"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                : [
                                                                                    _c(
                                                                                      "label",
                                                                                      {
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.onTableShowDialog(
                                                                                                "查看提成申诉",
                                                                                                "640px",
                                                                                                "chakanshensu",
                                                                                                scope.row,
                                                                                                scope.$index
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "查看提成申诉"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                            ],
                                                                            2
                                                                          )
                                                                        : _vm._e(),
                                                                      scope.row
                                                                        .bonusReviewStatusLabel
                                                                        ? _c(
                                                                            "li",
                                                                            [
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.onTableShowDialog(
                                                                                          "申诉记录",
                                                                                          "640px",
                                                                                          "shensujilu",
                                                                                          scope.row,
                                                                                          scope.$index
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "申诉记录"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      scope.row
                                                                        .bonusReviewStatus !==
                                                                        0 &&
                                                                      _vm.parArrayArr.indexOf(
                                                                        "fqxgtc"
                                                                      ) != -1
                                                                        ? _c(
                                                                            "li",
                                                                            [
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.onTableShowDialog(
                                                                                          "发起修改提成",
                                                                                          "640px",
                                                                                          "shensuxiugai",
                                                                                          scope.row,
                                                                                          scope.$index
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "发起修改提成"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  : _vm._e(),
                                                              ],
                                                              2
                                                            )
                                                          : _vm._e(),
                                                        _vm.typeStr !== "all" &&
                                                        _vm.typeStr !== "close"
                                                          ? _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "show-block",
                                                                attrs: {
                                                                  slot: "reference",
                                                                },
                                                                slot: "reference",
                                                              },
                                                              [
                                                                _vm._v("操作"),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-arrow-down",
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "goods"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item item-line",
                                          style: {
                                            zIndex: 3,
                                            minWidth: _vm.tableWith,
                                          },
                                        },
                                        [
                                          scope.row.orderNo
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-top": "2px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "tooltip",
                                                      attrs: {
                                                        "aria-label":
                                                          "点击复制",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.copyInfo(
                                                            scope.row,
                                                            "all"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "订单编号：" +
                                                          _vm._s(
                                                            scope.row.orderNo
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.typeStr !== "operation"
                                                    ? _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "relation-order",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "关联订单号：" +
                                                              _vm._s(
                                                                scope.row
                                                                  .platformOrderNo
                                                                  ? scope.row
                                                                      .platformOrderNo
                                                                  : "-"
                                                              )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.afterNo
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-top": "2px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "tooltip",
                                                      attrs: {
                                                        "aria-label":
                                                          "点击复制",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.copyInfo(
                                                            scope.row,
                                                            "afterOrder"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "售后编号：" +
                                                          _vm._s(
                                                            scope.row.afterNo
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.routeObj.name === "ordersList" ||
                                          _vm.routeObj.name ===
                                            "operatorsOrderList" ||
                                          (scope.row.submitDate &&
                                            _vm.isShowTime.submitDate)
                                            ? _c(
                                                "div",
                                                { staticClass: "hint_font" },
                                                [
                                                  _vm._v(
                                                    " 客户：" +
                                                      _vm._s(
                                                        scope.row.userName
                                                      ) +
                                                      "（" +
                                                      _vm._s(
                                                        scope.row.userPhone
                                                      ) +
                                                      "）"
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    " 提交审核时间：" +
                                                      _vm._s(
                                                        scope.row.status == 99
                                                          ? "-"
                                                          : scope.row.submitDate
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.routeObj.name ===
                                          "operatorsOrderList"
                                            ? _c(
                                                "div",
                                                { staticClass: "hint_pr" },
                                                [
                                                  _vm._v(
                                                    " 订单类型：" +
                                                      _vm._s(
                                                        scope.row.orderTypeLabel
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.routeObj.name ===
                                          "operatorsOrderList"
                                            ? _c(
                                                "div",
                                                { staticClass: "hint_pr" },
                                                [
                                                  _vm._v(
                                                    " 业绩归属人：" +
                                                      _vm._s(
                                                        scope.row
                                                          .achievementUserName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.applierName
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "hint_pr tooltip",
                                                  attrs: {
                                                    "aria-label": "点击复制",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyInfo(
                                                        scope.row,
                                                        "service"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " 跟进客服：" +
                                                      _vm._s(
                                                        scope.row.applierName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.createdTime &&
                                          _vm.isShowTime.createdTime
                                            ? _c(
                                                "div",
                                                { staticClass: "hint_pr" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.typeStr ===
                                                          "operation"
                                                          ? "提交时间"
                                                          : "下单时间"
                                                      ) +
                                                      "：" +
                                                      _vm._s(
                                                        scope.row.createdTime
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "hint_pr" },
                                            [
                                              _vm._v(
                                                " 资源来源：" +
                                                  _vm._s(
                                                    scope.row.platformName ||
                                                      "-"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.afterSale === "afterSale"
                                        ? [
                                            scope.row.afterRecords
                                              ? _c(
                                                  "div",
                                                  _vm._l(
                                                    scope.row.afterRecords,
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass: "mesSty",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-bottom":
                                                                  "6px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "bold",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "售后编号："
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.afterNo
                                                                ) + " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c("el-image", {
                                                            attrs: {
                                                              src: item.goodsImage,
                                                              fit: "cover",
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mesFont",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      item.goodsName +
                                                                      "*" +
                                                                      item.quantity,
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.goodsName
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.goodsSkuName
                                                                  ) +
                                                                    " * " +
                                                                    _vm._s(
                                                                      item.quantity
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ]
                                        : [
                                            scope.row.details
                                              ? _c(
                                                  "div",
                                                  _vm._l(
                                                    scope.row.details,
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass: "mesSty",
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            attrs: {
                                                              src: item.goodsImage,
                                                              fit: "cover",
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mesFont",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      item.goodsName +
                                                                      "*" +
                                                                      item.quantity,
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.goodsName
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.goodsSkuName
                                                                  ) +
                                                                    " * " +
                                                                    _vm._s(
                                                                      item.quantity
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ],
                                      _c("div", [
                                        !scope.row.details
                                          ? _c(
                                              "div",
                                              { staticClass: "mesSty" },
                                              [
                                                _c("el-image", {
                                                  attrs: {
                                                    src: scope.row.goodsImage,
                                                    fit: "cover",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "mesFont" },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        attrs: {
                                                          title:
                                                            scope.row
                                                              .goodsName +
                                                            "*" +
                                                            scope.row.quantity,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .goodsName
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("p", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            scope.row
                                                              .goodsSkuName
                                                          ) +
                                                          " * " +
                                                          _vm._s(
                                                            scope.row.quantity
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "contact"
                                  ? [
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [_vm._v(_vm._s(scope.row.postName))]
                                      ),
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [_vm._v(_vm._s(scope.row.postContact))]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "address"
                                  ? [
                                      _c("p", { staticClass: "address" }, [
                                        _vm._v(
                                          _vm._s(scope.row.postDetailedAddress)
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "amount"
                                  ? [
                                      _vm.typeStr === "operation"
                                        ? [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: { height: "23px" },
                                              },
                                              [
                                                _vm._v(
                                                  "总价：￥" +
                                                    _vm._s(
                                                      scope.row.totalAmount
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: { height: "23px" },
                                              },
                                              [
                                                _vm._v(
                                                  "总价：" +
                                                    _vm._s(
                                                      scope.row.totalAmount
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: { height: "23px" },
                                              },
                                              [
                                                _vm._v(
                                                  "已收：" +
                                                    _vm._s(
                                                      scope.row.receivedAmount
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: { height: "23px" },
                                              },
                                              [
                                                _vm._v(
                                                  "代收：" +
                                                    _vm._s(
                                                      scope.row.collectionAmount
                                                    )
                                                ),
                                              ]
                                            ),
                                          ],
                                    ]
                                  : _vm._e(),
                                _vm.afterSale === "afterSale"
                                  ? [
                                      _vm._l(
                                        scope.row.afterRecords,
                                        function (item, index) {
                                          return slot === "totalAmount"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "afterSaleAmount",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          height: "23px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "实付：￥" +
                                                            _vm._s(
                                                              item.totalAmount
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          height: "23px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "退款：￥" +
                                                            _vm._s(
                                                              item.refundAmount
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e()
                                        }
                                      ),
                                    ]
                                  : [
                                      slot === "totalAmount"
                                        ? [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: { height: "23px" },
                                              },
                                              [
                                                _vm._v(
                                                  "实付：￥" +
                                                    _vm._s(
                                                      scope.row.totalAmount
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: { height: "23px" },
                                              },
                                              [
                                                _vm._v(
                                                  "退款：￥" +
                                                    _vm._s(
                                                      scope.row.refundAmount
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                slot === "shenheMessage"
                                  ? [
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [
                                          _vm._v(
                                            " 审核人：" +
                                              _vm._s(
                                                scope.row.approverName
                                                  ? scope.row.approverName
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.approverTime
                                                ? scope.row.approverTime
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "notGo"
                                  ? [
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.rejectReason
                                                ? scope.row.rejectReason
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "order" && _vm.typeStr !== "operation"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { height: "23px" },
                                          attrs: {
                                            title: scope.row.subsetSatusLabel,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              {
                                                "danger-bg":
                                                  scope.row.status == 99,
                                              },
                                              {
                                                "warning-bg":
                                                  scope.row.status == 3,
                                              },
                                              "round",
                                            ],
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.subsetSatusLabel
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm.afterSale === "afterSale"
                                  ? [
                                      _vm._l(
                                        scope.row.afterRecords,
                                        function (item, index) {
                                          return slot === "order" &&
                                            _vm.typeStr === "operation"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "afterSaleStatus",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        attrs: {
                                                          title:
                                                            scope.row
                                                              .statusLabel,
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          class: [
                                                            {
                                                              "danger-bg":
                                                                scope.row
                                                                  .status == 99,
                                                            },
                                                            {
                                                              "warning-bg":
                                                                scope.row
                                                                  .status < 4,
                                                            },
                                                            "round",
                                                            {
                                                              "success-bg":
                                                                scope.row
                                                                  .status === 4,
                                                            },
                                                          ],
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .statusLabel
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e()
                                        }
                                      ),
                                    ]
                                  : [
                                      slot === "order" &&
                                      _vm.typeStr === "operation"
                                        ? [
                                            _c(
                                              "p",
                                              {
                                                attrs: {
                                                  title: scope.row.statusLabel,
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  class: [
                                                    {
                                                      "danger-bg":
                                                        scope.row.status == 99,
                                                    },
                                                    {
                                                      "warning-bg":
                                                        scope.row.status < 4,
                                                    },
                                                    "round",
                                                    {
                                                      "success-bg":
                                                        scope.row.status === 4,
                                                    },
                                                  ],
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.statusLabel
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                _vm.afterSale === "afterSale"
                                  ? [
                                      _vm._l(
                                        scope.row.afterRecords,
                                        function (item, index) {
                                          return slot === "afterSaleReason" &&
                                            _vm.typeStr === "operation"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "afterSaleStatus",
                                                  },
                                                  _vm._l(
                                                    _vm.dictionaries
                                                      .after_sale_reason,
                                                    function (it, el) {
                                                      return it.dictId ==
                                                        item.reason
                                                        ? _c("p", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  it.dictName
                                                                ) +
                                                                " "
                                                            ),
                                                          ])
                                                        : _vm._e()
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            : _vm._e()
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm.afterSale === "afterSale"
                                  ? [
                                      _vm._l(
                                        scope.row.afterRecords,
                                        function (item, index) {
                                          return slot === "approverInfo" &&
                                            _vm.typeStr === "operation"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "afterSaleStatus",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          height: "23px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.approverName
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          height: "23px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.approverTime
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e()
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm.afterSale === "afterSale"
                                  ? [
                                      _vm._l(
                                        scope.row.afterRecords,
                                        function (item, index) {
                                          return slot === "afterSaleStatus" &&
                                            _vm.typeStr === "operation"
                                            ? [
                                                item.afterSaleStep == "1"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "warning-bg round",
                                                        }),
                                                        _vm._v("审核中 "),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.afterSaleStep == "2"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "warning-bg round",
                                                        }),
                                                        _vm._v("待寄回 "),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.afterSaleStep == "3"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "warning-bg round",
                                                        }),
                                                        _vm._v("退货中 "),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.afterSaleStep == "4"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "warning-bg round",
                                                        }),
                                                        _vm._v("待换货 "),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.afterSaleStep == "5"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "warning-bg round",
                                                        }),
                                                        _vm._v("换货中 "),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.afterSaleStep == "6"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "warning-bg round",
                                                        }),
                                                        _vm._v("售后关闭 "),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.afterSaleStep == "7"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "danger-bg round",
                                                        }),
                                                        _vm._v("商家拒绝售后 "),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.afterSaleStep == "8"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "success-bg round",
                                                        }),
                                                        _vm._v("售后完成 "),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            : _vm._e()
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm.afterSale === "afterSale"
                                  ? [
                                      _vm._l(
                                        scope.row.afterRecords,
                                        function (item, index) {
                                          return slot === "caozuo" &&
                                            _vm.typeStr === "operation"
                                            ? [
                                                item.afterSaleStep == "4" ||
                                                item.afterSaleStep == "5"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "afterSaleStatus",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                              color: "#4168e7",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "查看寄回物流"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            : _vm._e()
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "examine"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          attrs: {
                                            title: scope.row.approveStatusLabel,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              {
                                                "danger-bg":
                                                  scope.row.approveStatus == 3,
                                              },
                                              {
                                                "warning-bg":
                                                  scope.row.approveStatus == 1,
                                              },
                                              {
                                                round: scope.row.approveStatus,
                                              },
                                            ],
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.approveStatusLabel
                                                  ? scope.row.approveStatusLabel
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "bonusStatus"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          attrs: {
                                            title:
                                              scope.row.bonusReviewStatusLabel,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              {
                                                "primary-bg":
                                                  scope.row
                                                    .bonusReviewStatus === 0,
                                              },
                                              {
                                                "info-bg":
                                                  scope.row
                                                    .bonusReviewStatus === 1,
                                              },
                                              {
                                                "success-bg":
                                                  scope.row
                                                    .bonusReviewStatus === 2 ||
                                                  scope.row
                                                    .bonusReviewStatus === 4,
                                              },
                                              {
                                                "danger-bg":
                                                  scope.row
                                                    .bonusReviewStatus === 3,
                                              },
                                              {
                                                round:
                                                  scope.row
                                                    .bonusReviewStatusLabel,
                                              },
                                            ],
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.bonusReviewStatusLabel
                                                  ? scope.row
                                                      .bonusReviewStatusLabel
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "auditStatus"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          attrs: {
                                            title: scope.row.auditStatusLabel,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              {
                                                "primary-bg":
                                                  scope.row.auditStatus === 0,
                                              },
                                              {
                                                "info-bg":
                                                  scope.row.auditStatus === 1,
                                              },
                                              {
                                                "success-bg":
                                                  scope.row.auditStatus === 2 ||
                                                  scope.row.auditStatus === 4,
                                              },
                                              {
                                                "danger-bg":
                                                  scope.row.auditStatus === 3,
                                              },
                                              {
                                                round:
                                                  scope.row.auditStatusLabel,
                                              },
                                            ],
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.auditStatusLabel
                                                  ? scope.row.auditStatusLabel
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "remarks"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.typeStr !== "operation",
                                              expression:
                                                "typeStr !== 'operation'",
                                            },
                                          ],
                                          staticStyle: { height: "23px" },
                                          attrs: { title: scope.row.remarks },
                                        },
                                        [
                                          _vm._v(
                                            " 客服备注：" +
                                              _vm._s(
                                                scope.row.remarks
                                                  ? scope.row.remarks
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { height: "23px" },
                                          attrs: {
                                            title: scope.row.userRemarks,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " 客户留言：" +
                                              _vm._s(
                                                scope.row.userRemarks
                                                  ? scope.row.userRemarks
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "bonusApply" &&
                                scope.row.orderBonusResponse
                                  ? [
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.orderBonusResponse
                                                .applyName
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { height: "23px" },
                                          attrs: {
                                            title: scope.row.orderBonusResponse
                                              .reason
                                              ? scope.row.orderBonusResponse
                                                  .reason
                                              : "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " 申诉备注：" +
                                              _vm._s(
                                                scope.row.orderBonusResponse
                                                  .reason
                                                  ? scope.row.orderBonusResponse
                                                      .reason
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "bonusEditPerson" &&
                                scope.row.orderBonusResponse
                                  ? [
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.orderBonusResponse
                                                .applyName
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { height: "23px" },
                                          attrs: {
                                            title: scope.row.orderBonusResponse
                                              .reason
                                              ? scope.row.orderBonusResponse
                                                  .reason
                                              : "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " 修改备注：" +
                                              _vm._s(
                                                scope.row.orderBonusResponse
                                                  .reason
                                                  ? scope.row.orderBonusResponse
                                                      .reason
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "auditRemarks" && scope.row
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          attrs: {
                                            title: scope.row.auditRemarks
                                              ? scope.row.auditRemarks
                                              : "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.auditRemarks
                                                  ? scope.row.auditRemarks
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "applyReason" && scope.row
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { height: "23px" },
                                          attrs: {
                                            title: scope.row.reason
                                              ? scope.row.reason
                                              : "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.reason
                                                  ? scope.row.reason
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "bonusKnow"
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.bonusKnowFlag == 1
                                              ? "已确认"
                                              : "未确认"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "bonusAudit" &&
                                scope.row.orderBonusResponse
                                  ? [
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.orderBonusResponse
                                                .auditUserName
                                            )
                                          ),
                                        ]
                                      ),
                                      scope.row.orderBonusResponse.auditUserName
                                        ? _c(
                                            "p",
                                            {
                                              staticStyle: { height: "23px" },
                                              attrs: {
                                                title: scope.row
                                                  .orderBonusResponse
                                                  .auditRemarks
                                                  ? scope.row.orderBonusResponse
                                                      .auditRemarks
                                                  : "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " 备注：" +
                                                  _vm._s(
                                                    scope.row.orderBonusResponse
                                                      .auditRemarks
                                                      ? scope.row
                                                          .orderBonusResponse
                                                          .auditRemarks
                                                      : "-"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                                slot === "operation"
                                  ? [
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [
                                          _vm._v(
                                            "操作人：" +
                                              _vm._s(scope.row.closedPersonName)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        { staticStyle: { height: "23px" } },
                                        [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(scope.row.closedTime)
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "orderOriginLabel"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "text-align": "left",
                                            height: "23px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.orderOriginLabel || "--"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "afterLogin"
                                  ? [
                                      [
                                        _c(
                                          "p",
                                          { staticStyle: { height: "23px" } },
                                          [
                                            _vm._v(
                                              "完好：" +
                                                _vm._s(scope.row.intact)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          { staticStyle: { height: "23px" } },
                                          [
                                            _vm._v(
                                              "破损：" +
                                                _vm._s(scope.row.damaged)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          { staticStyle: { height: "23px" } },
                                          [
                                            _vm._v(
                                              "漏件：" +
                                                _vm._s(scope.row.missingParts)
                                            ),
                                          ]
                                        ),
                                      ],
                                    ]
                                  : _vm._e(),
                                slot === "afterLoginL"
                                  ? _vm._l(
                                      scope.row.details,
                                      function (itm, inx) {
                                        return _c(
                                          "div",
                                          {
                                            key: inx,
                                            staticStyle: {
                                              height: "128px",
                                              display: "flex",
                                              "justify-content": "center",
                                              "flex-direction": "column",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "完好：" +
                                                      _vm._s(itm.intact || 0)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "破损：" +
                                                      _vm._s(itm.damaged || 0)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "漏件：" +
                                                      _vm._s(
                                                        itm.missingParts || 0
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._e(),
                                slot === "claimFlagLabelL"
                                  ? _vm._l(
                                      scope.row.details,
                                      function (itm, inx) {
                                        return _c(
                                          "div",
                                          {
                                            key: inx,
                                            staticStyle: {
                                              height: "128px",
                                              display: "flex",
                                              "justify-content": "center",
                                              "flex-direction": "column",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      itm.claimFlagLabel || "--"
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._e(),
                                slot === "claimAmountL"
                                  ? _vm._l(
                                      scope.row.details,
                                      function (itm, inx) {
                                        return _c(
                                          "div",
                                          {
                                            key: inx,
                                            staticStyle: {
                                              height: "128px",
                                              display: "flex",
                                              "justify-content": "center",
                                              "flex-direction": "column",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(
                                                        itm.claimAmount ||
                                                          "0.00"
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._e(),
                                slot === "remarksL"
                                  ? _vm._l(
                                      scope.row.details,
                                      function (itm, inx) {
                                        return _c(
                                          "div",
                                          {
                                            key: inx,
                                            staticStyle: {
                                              height: "128px",
                                              display: "flex",
                                              "justify-content": "center",
                                              "flex-direction": "column",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(itm.remarks || "--")
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._e(),
                                slot === "afterTypeLabelL"
                                  ? _vm._l(
                                      scope.row.details,
                                      function (itm, inx) {
                                        return _c(
                                          "div",
                                          {
                                            key: inx,
                                            staticStyle: {
                                              height: "128px",
                                              display: "flex",
                                              "justify-content": "center",
                                              "flex-direction": "column",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      itm.afterTypeLabe || "--"
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._e(),
                                slot === "claimAmount"
                                  ? [
                                      [
                                        _c(
                                          "p",
                                          { staticStyle: { height: "23px" } },
                                          [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(
                                                  scope.row.claimAmount ||
                                                    "0.00"
                                                )
                                            ),
                                          ]
                                        ),
                                      ],
                                    ]
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        align: align,
                      },
                    }),
              ]
            }
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }